import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19fbede7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "home_slider1"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slide = _resolveComponent("slide")!
  const _component_navigation = _resolveComponent("navigation")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_carousel = _resolveComponent("carousel")!

  return (_ctx.bannerListData.length > 0 && _ctx.isDataFetched)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_carousel, {
          autoplay: 2500,
          pauseAutoplayOnHover: true,
          itemsToShow: _ctx.itemsToShow,
          wrapAround: true,
          transition: 500
        }, {
          addons: _withCtx(() => [
            _createVNode(_component_navigation),
            _createVNode(_component_pagination)
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerListData, (banner) => {
              return (_openBlock(), _createBlock(_component_slide, {
                key: banner.bannerName
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: banner.bannerUrl,
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.appDir + `/images/${banner.bannerImgFileName}`,
                      alt: "banner.bannerName"
                    }, null, 8, _hoisted_3)
                  ], 8, _hoisted_2)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["itemsToShow"])
      ]))
    : _createCommentVNode("", true)
}